<template>
 
   	 <!-- :style="{backgroundImage:'url('+require('@/assets/images/shenpi1.png')+')'}" -->
        
    <div id='stafflist'     >  
   
  

        <div class="wrap" :style="'min-height:'+screenHeight+'px;width:'+screenWidth+'px'">
        
            <!-- <el-tabs :stretch="true" tab-position="left" class="el-tabs "  > 
                <el-tab-pane label="全部"  >   全部 </el-tab-pane>
                <el-tab-pane label="我的客户"  >   我的客户 </el-tab-pane>
                <el-tab-pane label="我的案件">我的案件</el-tab-pane>
                <el-tab-pane label="我的用印">我的用印</el-tab-pane>
                <el-tab-pane label="我的开票">我的开票</el-tab-pane>
                <el-tab-pane label="我的退款">我的退款</el-tab-pane>
            </el-tabs> -->
           

         
           
           
            <div class="left unify_bg"> 

                <div class="check_all  " @click="getStaffs">全部</div>
        
                    <el-tree :data="org" :props="defaultProps" @node-click="handleNodeClick" class="unify_bg" style="min-height:400px; width:65%;padding:10px 10px 10px 40px; "></el-tree>

                </div>

          
 
                <div   class="right"   :style="'width:'+(screenWidth-270)+'px'"> 

                    <div style=" width:90%;margin-bottom:30px;margin-top: 15px;">
            

                        <el-select
                            style="width:70%; "
                            clearable
                            @keyup.enter.native="handleSelectConfirm()"
                            @change="handleSelectConfirm()"
                            v-model="selectValue"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入姓名搜索"
                            :remote-method="remoteMethod"
                            :loading="loading">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item">
                            </el-option>
                            <!-- :value="item.value" -->
                        </el-select>
                    
                    </div>
          
                    <el-table
                        :data="onshowList.slice(10*(page-1),10*(page-1)+10)"
                        stripe
                        style="width: 90%; min-height:700px;padding-left: 20px;padding-top:20px;border-radius:15px">
                        <el-table-column
                            label="编号"
                            width="50"
                            type="index">
                            <!-- {{index}} -->
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="姓名"
                            width="200">
                        </el-table-column>
                        <el-table-column
                            prop="gender"
                            label="性别"
                            width="60">
                        </el-table-column>
                        
                        <el-table-column
                            prop="phone"
                            label="电话"
                            width="140">
                        </el-table-column>
                        <el-table-column
                            prop="depart.depart"
                            label="部门"
                            width="160">
                        </el-table-column>
                        <el-table-column
                            prop="email"
                            label="邮箱"
                            width="200">
                        </el-table-column>
                        <!-- <el-table-column
                            prop="arrivalDate"
                            label="入职日期"
                            width="120">
                        </el-table-column>
                        <el-table-column
                            prop="birthDay"
                            label="生日"
                            width="120">
                        </el-table-column> -->
                        
                        <!-- <el-table-column
                            fixed="right"
                            label="操作">
                    
                            <template slot-scope="scope">
                                <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                                <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            </template>


                        </el-table-column> -->
                    </el-table>


 


                <!-- <div class="list" v-if="mode=='list'"> </div> -->

 

                <div class="page_box">
                    <Pages style="margin-top:30px;float:right" :pageTotal="pageTotal" :pageSize="10" @ChangePage="ChangePage"></Pages>
                </div>

            </div>

     

        </div>

    

    </div>


 
</template>

<script>

import Pages from '@/components/Pages.vue'
 
 

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

var filters = {
    toFix: function (value) {
        return value.toFixed(2)//此处2为保留两位小数
    }
}  
    let id = 1000;
 

	export default {
 
        name: 'stafflist',
        // metaInfo () {
        //     return {
        //         title: '诉讼费计算器'
        //     }
        // },
        props: {
			isPhone: Boolean
        },
        components: { 
   
            Pages,
         
 
        },
		// placeholder:"hi",
        data() {
            const data = [{
                id: 1,
                label: '管委会',
                value:1

            }, {
                id: 2,
                label: '合伙人会议',
                value:2

            }, {
                id: 3,
                label: '业务部门',
                value:3,
                
                children: [{
                id: 7,
                label: '授薪律师',
                value:7,
                }, {
                id: 8,
                label: '提成律师',
                value:8,
                },
                ]
            }];
           
			return { 
                org: JSON.parse(JSON.stringify(data)),

                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                // screenWidth:window.innerWidth
                search_word:'',
                flow:[],
                list:[],

                // mode:'list',  //'detail
                // info:{"1":"业务信息" ,"1-all":"全部" , "1001":"我的客户" ,"1002":"我的案件","1003":"我的开票","1004":"我的用印","1005":"我的退款"},
                // bread:['业务信息','全部','列表'],
                // current_item:"1-all",
                // current_template_id:'',
                // pages:{"1-all":0, "search":0 },
                loading: false,
                // sheet:'',
                // form:'',
                // totalNumber:0,

                isallset:false,
                onshowList:[],
                stafflist:[],
                selectValue:'',
                options:'',
                state: '',
                timeout:null,

                defaultProps: {
                    children: 'children',
                    label: 'label'
                },

                search_list:[],
                pageTotal:0,
                page:1,
                 
     
            }

        },
        created(){
            this.getStaffs()
          
        },
        mounted(){
     
           
        },
        methods:{

            timestampToTime(timestamp) {
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + '';
                // var h = date.getHours() + ':';   //
                // var m = date.getMinutes() + ':';//
                // var s = date.getSeconds();//
                if (M.length==1){
                    M='0' +M
                }
                if (D.length==1){
                    D='0' +D
                }
                return Y + M + D ;  //+ h + m + s
            },


            ChangePage(page){
                // console.log('--==-== page:',page);
                this.page=page


            },

            // GetAllFlow_Count(){
            //     var that=this
            //     var data= { 
            //         whattodo: "Get_Company_Structure",
            //         // page:page
            //     }
                

            //     const loading = this.$loading({
            //         lock: true,
            //         text: 'Loading',
            //         spinner: 'el-icon-loading',
            //         background: 'rgba(0, 0, 0, 0.7)'
            //     });

       

            //     this.axios.post('https://api.lawtip.cn/oa',data
            //     ).then(function (res) {
            //         window.console.log(res)
            //         if(res.status==200){
            //             let result=res.data
            //             console.log('result:',result)
            //             if(result.status=='ok'){
         
            //             }

            
        
            //         }
                
            //         loading.close();
                    
            //     }).catch(function (error) {
            //         window.console.log(error);
            //         loading.close();
                
            //     });


            // },



           getStaffs(){
                var that=this
                var data= { 
                    whattodo: "get_staff_list",
                    // staff:this.form
                }
                that.isallset=false
                this.axios.post(this.$root.rootUrl+'oa',data
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        // console.log('result:',result)
                        if(result.status=='ok'){
                            that.stafflist=result.data.staff
                            that.org=result.data.org.children
                            that.onshowList=that.stafflist
                            let len=that.stafflist.length
                            that.pageTotal=len
                            if (len<1000){
                                that.isallset=true
                            }
                            // var namelist=[];
                            // for (let i=0;i<len;i++){

                            // }

                            that.list = that.stafflist.map((item,index) => {
                                return { value: `value:${item.name}`, label: `${item.name}` ,"staff_id":item.staff_id ,"ind": index};
                            });

                            // console.log('list:',that.list)

                        }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });




            },


            remoteMethod(query) {

                // console.log('remoteMethod')
                if (query !== '' && this.isallset) {
       
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options = this.list.filter(item => {
                        return item.label.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                    } else {
                    this.options = [];

 
                }

                if(query !== '' && !this.isallset){
                    this.SearchStaff(query)



                }

                // this.SearchStaff(query)

            },


            SearchStaff(keyword){
                var that=this
                var data= { 
                    whattodo: "search_staff",
                    keyword:keyword
                }
                that.isallset=false
                this.axios.post(this.$root.rootUrl+'oa',data
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        // console.log('result:',result)
                        if(result.status=='ok'){
                            let staff_arr=[]
                            let ind=0
                            for (let p of result.data){
                                p.staff.label=p.staff.name
                                p.staff.value=p.staff.value
                                p.staff.ind=ind
                                staff_arr.push(p.staff)
                                ind++
                            }
                            that.options=staff_arr
                            that.search_list=staff_arr

                            // console.log('that.options:',that.options)

                            // that.list = that.options.map((item,index) => {
                            //     return { value: `value:${item.name}`, label: `${item.name}` ,"staff_id":item.staff_id ,"ind": index};
                            // });



                           

                        }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });



            },



            handleSelectConfirm() {
                this.page=1
                // window.console.log('handleSelectConfirm event ,this.selectValue:',this.selectValue)
                if(!this.selectValue){
                   

                    this.onshowList=this.stafflist
                    
                    // console.log("this.stafflist:",this.stafflist)
                    // console.log("this.onshowList:",this.onshowList)
                     
                }else{

                    if(this.isallset){
                        this.onshowList=[this.stafflist[this.selectValue.ind]]
                        // console.log('111111111111111')
                    }else{
                        this.onshowList=[this.search_list[this.selectValue.ind]]

                        // console.log('22222222222')
                    }




                }

      
                this.pageTotal=this.onshowList.length
                 
                

                // console.log('this.search_list:',this.search_list);

                 



                // let selectValue = this.selectValue;
                // if (selectValue) {
                //     this.procedure[index].staff.push(selectValue);
                // }
                // this.tempsig = false;
                // this.selectValue = '';
            },


       
          
            handleNodeClick(data) {
                this.isallset=false
                // console.log(data);

                this.get_org_staff(data.value)





            },



            get_org_staff(code){

                var that=this
                var data= { 
                    whattodo: "get_org_staff",
                    // staff:this.form，
                    org_code:code
                }
                that.isallset=false
                this.axios.post(this.$root.rootUrl+'oa',data
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        // console.log('result:',result)
                        if(result.status=='ok'){
                            // let staff_arr=[]
                            // for (let p of result.data){
                            //     staff_arr.push(p.staff)
                            // }


                            // that.stafflist=staff_arr
                            // console.log("that.stafflist:",that.stafflist)
                            // // that.org=result.data.org.children
                            // that.onshowList=that.stafflist
                            // let len=that.stafflist.length
                            // that.pageTotal=len
                            // if (len<1000){
                            //     that.isallset=true
                            // }

                            that.stafflist=result.data
                    
                            that.onshowList=that.stafflist
                            let len=that.stafflist.length
                            that.pageTotal=len
                            if (len<1000){
                                that.isallset=true
                            }
                        

                            that.list = that.stafflist.map((item,index) => {
                                return { value: `value:${item.name}`, label: `${item.name}` ,"staff_id":item.staff_id ,"ind": index};
                            });

                            // console.log('list:',that.list)

                        }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });




            }




           
          
            
          



        }
    
	}
</script>



<style  >
  .wrap{
    display: flex;
    flex-direction: row;

    margin-bottom: 100px;
  }

   .check_all{
    width:100%;
    height:80px;
    line-height:80px;
    text-align:center;
  
    margin-bottom: 10px;
    cursor: pointer;

    /* border:1px solid rgb(185, 192, 186); */
 }

  .wrap .left{
      width:240px;
      /* border-right:1px solid rgb(191, 192, 185); */
        /* border:1px solid rgb(191, 192, 185); */
      display: flex;
      flex-direction: column;
      align-items: center;
     
  }
 
 .wrap .right{
    /* width:100%; */
    /* border:1px solid rgb(191, 192, 185); */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

 }

 

 
 .bread{
    width:50%;
    height: 100%;
    line-height: 70px;
    padding-left:15px;
   
    
 }
 .el-breadcrum{
    height: 70px;
    display: flex;
    flex-direction: row;
    /* justify-content: center; */
    align-items: center;
    font-size:16px;
 }
 .navibox{
    height: 70px;
    width:100%;
    /* border:1px solid rgb(191, 192, 185); */
    display: flex;
    flex-direction: row;

 }

 .searchbox{
    /* float:right; */
    /* border:1px solid rgb(191, 192, 185); */
    width:50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    /* background-color: #e2e6ebe5; */
    
 }


.el-tabs {

    border:1px solid rgb(191, 192, 185);
    width:100%;
    /* font-size:18px; */
}


.el-tabs__item {
  font-size: 16px !important;
  /* padding: 10px 0 50px !important; */
  width: 220px !important;
}


.list{
    width:90%;
    display: flex;
    flex-direction: column;
    align-items: center;
   
    margin:0 auto 0 auto;

    padding-top: 30px;

    /* border:1px solid rgb(191, 192, 185); */
    color: #606266;

     
}

.form_box{

    padding-top: 20px;
    padding-bottom: 20px;

}

.bread_list{
    cursor:pointer;
    color:blue;
    /* text-decoration: underline; */
    /* color:blue;
    text-decoration: solid; */
}


.item{
    width:90%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    /* border:1px solid rgb(191, 192, 185); */

    display: flex;
    flex-direction: row;
    align-items: center;

    cursor: pointer;

}

.item .p1{
    width:10%;
    height: 100%;
    /* border:1px solid rgb(191, 192, 185); */

}

.item .p2{
    width:70%;
    height: 100%;
    /* border:1px solid rgb(191, 192, 185); */

}

.item .p3{
    width:20%;
    height: 100%;
    /* border:1px solid rgb(191, 192, 185); */

}

.page_box{
    width:100%;
    height: 80px;
    margin-bottom: 50px;
    /* border:1px solid rgb(191, 192, 185); */
    /* display: flex;
    flex-direction: row; */
    /* align-items: center; */
    line-height: 50px;
}

.page_box{
    width:100%;
    height: 80px;
    margin-bottom: 50px;
    /* border:1px solid rgb(191, 192, 185); */
    /* display: flex;
    flex-direction: row; */
    /* align-items: center; */
    line-height: 50px;
}

</style>


 